import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const TalukaService = {
  get: async (offset, limit, searchQuery, state_id, district_id) => {
    try {
      const response = await axios.get(
        ApiConstants.taluka.baseUrl +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}&state_id=${
            state_id ?? ""
          }&district_id=${district_id ?? ""}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAll: async (district_id) => {
    try {
      const response = await axios.get(
        ApiConstants.taluka.getAll + `?district_id=${district_id ?? ""}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.taluka.delete,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.taluka.changeStatus,
        {
          id: id,
          isActive: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  create: async (name, district_id) => {
    try {
      const response = await axios.post(
        ApiConstants.taluka.baseUrl,
        {
          name: name.trim(),
          district_id: district_id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  update: async (id, name) => {
    try {
      const response = await axios.put(
        ApiConstants.taluka.baseUrl,
        {
          name: name.trim(),
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default TalukaService;
